import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,_vm._g(_vm._b({attrs:{"value":_vm.displayValue,"min":"0","prefix":_vm.prefix,"type":"number"}},'v-text-field',this.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }